module.exports = __webpack_public_path__ + "img/20190514171204b_02.d5d0dd94.png";